import h, { Component as b } from "react";
import e from "prop-types";
import u from "classnames";
import './TextArea.css';const m = "TextArea-module__text_area___abZSP", _ = "TextArea-module__disabled___N09tP", s = {
  text_area: m,
  disabled: _
};
class r extends b {
  constructor() {
    super(), this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props.focus && this.el.focus();
  }
  handleChange(a) {
    this.props.onChange(a.target.value);
  }
  render() {
    const {
      rows: a,
      value: l,
      placeholder: t,
      disabled: i,
      name: d,
      id: o,
      ariaDescribedBy: n,
      ariaLabelledBy: c
    } = this.props;
    return /* @__PURE__ */ h.createElement(
      "textarea",
      {
        id: o,
        "aria-describedby": n,
        "aria-labelledby": c,
        ref: (p) => {
          this.el = p;
        },
        name: d,
        className: u(s.text_area, this.props.className, {
          [s.disabled]: this.props.disabled
        }),
        rows: a,
        placeholder: t,
        value: l,
        disabled: i,
        onChange: this.handleChange
      }
    );
  }
}
r.propTypes = {
  /** class name */
  className: e.string,
  /** the function to be called on change (should change what is passed in for value). Returns what is typed in. */
  onChange: e.func.isRequired,
  /** the value of the textarea */
  value: e.string.isRequired,
  /** the placeholder text */
  placeholder: e.string,
  /** number of rows (height) */
  rows: e.number,
  /** Whether text area is disabled or not */
  disabled: e.bool,
  /** whether textarea should be focused on mount */
  focus: e.bool,
  /** the 'name' property of the text area */
  name: e.string,
  /** the 'id' property of the text area */
  id: e.string,
  /** HTML id of corresponding description for accessibility */
  ariaDescribedBy: e.string,
  /**
   * HTML id of corresponding label for accessibility.
   *
   * **Note:**
   * This should be set to ensure the component is
   * accessible and usable by assistive technologies.
   */
  ariaLabelledBy: e.string
};
r.defaultProps = {
  className: void 0,
  rows: 6,
  disabled: !1,
  focus: !1,
  name: null,
  placeholder: "",
  id: null,
  ariaDescribedBy: null,
  ariaLabelledBy: null
};
export {
  r as T
};
